import React from "react";
import { Button, Space, Alert } from "antd";

const FooterActions = ({
  onSave,
  isSaving,
  hasRequiredMissing,
  canEdit,
  isWOCompleted = false
}) => {
  return (
    <div className="mt-4">
      {hasRequiredMissing && canEdit && (
        <Alert
          message="Required fields are missing"
          description="Please fill in all required fields before saving."
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      {isWOCompleted && (
        <Alert
          message="Work Order Completed"
          description="This work order has been completed. Editing is disabled."
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}

      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Space>
          <Button
            type="primary"
            onClick={onSave}
            loading={isSaving}
            disabled={!canEdit || isWOCompleted || hasRequiredMissing}
          >
            {isWOCompleted ? "View Only" : "Save Changes"}
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default FooterActions;
